// extracted by mini-css-extract-plugin
export default {"updatePassword":"UpdatePassword_updatePassword__xExam","root":"UpdatePassword_root__kP8Eg","CodeMirror":"UpdatePassword_CodeMirror__Cmeau"};